import React, { useEffect, useState, useRef } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../layout/Noticia.Module.css';
import { news as originalNews } from '../noticias';
import translateText from './translateText';
import emailjs from '@emailjs/browser'
import { useTranslation } from 'react-i18next';
import { useLanguage } from './LanguageContext';
import { ContentRenderer } from './ContentRenderer';
const Noticia =({data}) =>{
    let {id} = useParams();
    const { selectedLanguage } = useLanguage(); // Obtém o idioma atual
    const { t, i18n } = useTranslation('');
    const [filteredNews, setFilteredNews] = useState([]);
    const form = useRef();
    
const [name, setName] = useState('')
const [tele, seTele] = useState('')
const [email, setEmail] = useState('')
const [sector, setSector] = useState('')
const [city, setCity] = useState('')
const [address, setAddress] = useState('')
const [cp, setCp] = useState('')
const [cv, setCv] = useState('')
const [file, setFile] = useState(null);
const [error, setError] = useState('')

const translatedNoti = originalNews.find((n) => n.id.toString() === id);
const filtered = originalNews.filter((n) => n.id.toString() !== id);

const [vaga, setVaga] = useState(translatedNoti.title[selectedLanguage]);

const handleFileChange = (e) => {
  setFile(e.target.files[0]);
};

const handleDownload = (e) => {
  e.preventDefault();

  emailjs.sendForm('service_x1e69vs', 'template_yihobfk', form.current, 'RXwAqTYouJEJek7HF')
    .then(
      () => {
        alert('Candidatura enviada com sucesso!');
        console.log('SUCCESS!');
      },
      (error) => {
        console.error('Falha ao enviar o formulário:', error);
      }
    );
};

const handleLinkChange = (e) => {
  const url = e.target.value;
  // Exemplo de verificação: URL válida e termina com .pdf
  const pdfPattern = /^https?:\/\/.*\.pdf$/i;
  if (!pdfPattern.test(url)) {
    alert("Por favor, insira um link válido para um arquivo PDF.");
  } else {
    // Armazene o link ou envie para o backend conforme necessário
    console.log("Link do currículo:", url);
  }
};

  return (
        <div className='pag-noticia'>
        <div className="container">
            
        <div className="row">
          <main className='col-md-10 col-lg-8 col-xxl-7'>
            <div className="header-block">
                <div className="title">
                <h1 className="title__name">{translatedNoti.title[selectedLanguage]}</h1>
                </div>
                <ul className="list-inline list-inline-dashed">
                  <li className="font-italic link-news"><Link to={`/noticias/`}>{t('homepage.titleNoticias')}</Link></li>
                </ul>
            </div>

            <div className="content">
            <div className='descri-news'>{translatedNoti.descri[selectedLanguage]}</div>
                <img src={translatedNoti.imgP}/>
                <br /><br />
                {translatedNoti.content?.map((item, index) => (
                <div className="inset-lg-right-35 inset-xxl-right-0 content-text" key={index}>
                {item.title && <h4 dangerouslySetInnerHTML={{__html: item.title[selectedLanguage]}}></h4>}
                {item.text && <p>{item.text[selectedLanguage]}</p>}
                {item.img2 && <img src={item.img2} className="image2-news mb-4" alt="Imagem Secundária" />}
                {item.list && (
                <ul className='list-news mb-2'>
                  {item.list.map((listItem, listIndex) => (
                    <li className='items-news' key={listIndex} dangerouslySetInnerHTML={{__html: listItem.element[selectedLanguage]}}></li>
                  ))}
                </ul>
                 )}
                  {item.img1 && <img src={item.img1} alt="Imagem" />}
                </div>
              ))}
             <ContentRenderer blocks={translatedNoti.blocks} lang={selectedLanguage}  /> 
            <div className='recru-info'>
            {translatedNoti.type === 'recru' && (
              <>
                <div className="recru-title fw-bold">{t('noticia.perfil')}</div>
                {translatedNoti.perfil?.map((pr, index) => (
                  <div className='recru' key={index}><li>-{pr.name[i18n.language]}</li></div>
                ))}

              {translatedNoti.functions && translatedNoti.functions.length > 0 && (
                <>
                  <div className="recru-title fw-bold">{t('noticia.funcoes')}</div>
                  {translatedNoti.functions.map((pr, index) => (
                    <div className='recru' key={index}>
                      <li>-{pr.name}</li>
                    </div>
                  ))}
                </>
              )}
                <div className="recru-title  fw-bold">{t('noticia.ofere')}</div>
                {translatedNoti.offers?.map((pr, index) => (
                  <div className='recru' key={index}><li>-{pr.name[i18n.language]}</li></div>
                ))}
              </>
            )}
              </div>
            </div>
            </main>
        {/*Outras noticias*/}
        <div className="col-md-10 col-lg-4 more-news">
        <hr className="divider hr-left-0 bg-bermuda"></hr>
        <h3>{t('noticia.outrasnoti')}</h3>
            {filtered.map((item, index) => (
              <li className={`news-card`} key={index}>
                <Link to={`/noticia/${item.id}`} className='other-news'>
                  <div className="article">
                    <div className="article-left">
                      <img src={item.imgP} alt="" />
                    </div>
                    <div className="article-right">
                      <h2>{item.title[selectedLanguage]}</h2>
                    </div>
                  </div>
                </Link>
              </li>
            ))}
        </div>
     </div>
    </div>

    {(translatedNoti.type === 'recru') && (
      <div className="recruitment-form">
        <div className="apply_box">
        <h1>{t('recru.candida')}</h1>
        
        <div className="uvc-heading-spacer line_only">
          <span className="uvc-headings-line" />
        </div>

        <form ref={form} className='form-download row g-3 needs-validation' onSubmit={handleDownload} method='POST'>
          <div className="form_container">

          <div className="form_control">
              <label htmlFor="first name">Vaga</label>
              <input id="first name" value={vaga} name="from_vaga" onChange={(e) => setVaga(e.target.value)} readOnly placeholder="Enter name" required/>
            </div>

            <div className="form_control">
              <label htmlFor="first name">{t('recru.nome')} *</label>
              <input id="first name" value={name} name="from_name" onChange={(e) => setName(e.target.value)} placeholder="Enter name" required/>
            </div>

            <div className="form_control">
              <label htmlFor="phone">{t('recru.tele')}*</label>
              <input type="text" value={tele} name="from_phone" onChange={(e) => seTele(e.target.value)} id="phone" placeholder="phone" />
            </div>

            <div className="form_control">
              <label htmlFor="email">Email *</label>
              <input  id="email" type="email" name="from_email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="john@doe.com" />
            </div>

            {/*
              <div className="form_control">
              <label htmlFor="job">{t('recru.setor')}</label>
              <select id="job" value={sector} name="" onChange={(e) => setSector(e.target.value)}>
                <option value="">{t('recru.setorp')} </option>
                <option value="Marketing">{t('recru.marke')}</option>
                <option value="Recursos humanos">{t('recru.rh')}</option>
                <option value="Armazém">{t('recru.ar')} </option>
                <option value="Admnistração">{t('recru.admi')}</option>
                <option value="Comercial">{t('recru.co')}</option>
                <option value="Finanças">{t('recru.fi')}</option>
                <option value="Outros">{t('recru.outros')}</option>(e A PESSOAL ESCREVER O QUE É)
              </select>
            </div>
            */}

            <div className="textarea_control">
              <label htmlFor="address">{t('recru.mo')}</label>
              <textarea cols="50" id="address" name="from_address" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Rua X"  row="4" />
            </div>
            <div className="form_control">
              <label htmlFor="city">{t('recru.cidade')}</label>
              <input id="city" name="from_city" value={city} onChange={(e) => setCity(e.target.value)} placeholder="Porto"/>
            </div>
            <div className="form_control">
              <label htmlFor="postalcode">{t('recru.capacidad')}</label>
              <input id="postalcode" name='from_cp' value={cp} onChange={(e) => setCp(e.target.value)} placeholder="XXXX-XXX" type="text"/>
            </div>
            <div className="form_control">
              <label htmlFor="cv">{t('recru.cv')}</label>
              <input id="cv" name='from_cv' value={cv} onChange={(e) => setCv(e.target.value)} placeholder={t('recru.inserircv')} type="url"/>
            </div>

          </div>
          <div className="button_container">
            <button className='submit' type="submit">{t('recru.candida')}</button>
          </div>
        </form>

      </div>
    </div>)} 
    </div>
  )
}
export default Noticia